<template>
  <component
    :is="el(href)"
    :to="href"
    :href="href"
    :target="target"
  >
    <slot />
  </component>
</template>
<script>
export default {
  name: 'generic-link',
  props: {
    href: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'router-link'
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  methods: {
    el: function() {
      return (/^#|http(s)?:\/\//.test(this.href)) ? 'a' : this.tag
    }
  }
}
</script>
